<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import {
  // mapActions,
  mapGetters
} from 'vuex';

// import store from '@/store/index'
// import WorkPackageLarge from '@/components/WorkPackages/WorkPackageLarge.component.vue';
export default {
  components: {
    // WorkPackageLarge
  },
  props: ['tworkpackage_id'],
  data: () => ({
    statusArray: ['ready', 'started', 'done', 'checked', 'closed', 'stop']
  }),
  // beforeRouteEnter(to, from, next) {
    // store.dispatch('Ultra/requestUObject', {
    //     url: [
    //       {projects: to.params.project_id},
    //       {trains: to.params.train_id},
    //       {taktareas: to.params.taktarea_id},
    //       {twaggons: to.params.twaggon_id},
    //       {tworkpackages: to.params.tworkpackage_id},
    //       {showWithEntitiesNormalized: ''}
    //     ]
    //   })
    //   .then(() => {
    //     next();
    //   });
  // },
  // beforeRouteEnter(to, from, next) {
  //   store.dispatch('TWorkPackage/requestTWorkPackage', {
  //       project_id: to.params.project_id,
  //       train_id: to.params.train_id,
  //       taktarea_id: to.params.taktarea_id,
  //       twaggon_id: to.params.twaggon_id,
  //       twork_package_id: to.params.tworkpackage_id
  //     })
  //     .then(() => {
  //       next();
  //     });
  // },
  computed: {
    getTWorkPackageColor() {
      return this.getTWorkPackage(this.tworkpackage_id).color;
    },
    getTWorkPackageDescription() {
      return this.getTWorkPackage(this.tworkpackage_id).description;
    },
    getTWorkPackageIcon() {
      return this.getTWorkPackage(this.tworkpackage_id).icon;
    },
    getTWorkPackageTextcolor() {
      return this.getTWorkPackage(this.tworkpackage_id).textcolor;
    },
    getTWorkPackageToken() {
      return this.getTWorkPackage(this.tworkpackage_id).token;
    },
    getTWorkPackageText() {
      return this.getTWorkPackage(this.tworkpackage_id).text;
    },
    ...mapGetters('TWorkPackage', [
      'getTWorkPackage',
    ]),
    currentPath(){
      return this.$route.name;
    }
  },
  methods: {
    openImageOverview(){
      this.$router.push({
        name: 'TaktPlanWorkPackageImageOverView',
      })
    },
    openInfo(){
      this.$router.push({
        name: 'TaktPlanWorkPackageInfo',
      })
    },
    openLogList(){
      this.$router.push({
        name: 'TaktPlanWorkPackageLogList',
      })
    },
    openWorksteps(){
      this.$router.push({
        name: 'TaktPlanWorkPackageWorkSteps',
      })
    },
  }
}
</script>
<style lang="css" scoped>

</style>
